var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.84793L1.8911 0.239633C1.7367 0.0853652 1.53071 0.000243114 1.31106 -6.2898e-08C1.09129 -5.23545e-08 0.885057 0.0851211 0.730901 0.239634L0.239527 0.731097C0.084761 0.88561 -5.53928e-07 1.09159 -5.45171e-07 1.31146C-5.36428e-07 1.53098 0.0847611 1.73695 0.239527 1.89146L5.84806 7.49976L0.239528 13.1083C0.0847615 13.2626 -6.09884e-08 13.4687 -5.22363e-08 13.6884C-4.34938e-08 13.9079 0.0847616 14.114 0.239528 14.2683L0.730901 14.76C1.05092 15.08 1.57144 15.08 1.8911 14.76L7.5 9.15158L13.1087 14.76C13.2633 14.9144 13.4693 14.9994 13.6889 14.9994C13.9086 14.9994 14.1146 14.9144 14.2691 14.76L14.7605 14.2684C14.9151 14.1141 15 13.9079 15 13.6885C15 13.4688 14.9151 13.2627 14.7605 13.1084L9.15181 7.49988L14.7605 1.89158C14.9151 1.73707 15 1.5311 15 1.31158L15 1.31134C15 1.09171 14.9151 0.885731 14.7605 0.731219L14.2691 0.239756C14.1147 0.0854876 13.9086 0.00036459 13.6889 0.000364601C13.4693 0.000364611 13.2633 0.0854877 13.1088 0.239756L7.5 5.84793Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseCross);
export default __webpack_public_path__ + "static/media/icon-close-cross.4ca5e444ff877e10aabd369e7b12c5be.svg";
export { ForwardRef as ReactComponent };